import { createSlice } from "@reduxjs/toolkit";

export const solutionsListSlice = createSlice({
  name: "solutionsList",
  initialState: {
    byId: {},
    allIds: [],
    totalRecords: 0,
    selectedSolution: null,
    filteredRecords: 0,
    isSingleSolutionLoading: false,
    isLoading: false,
    isAnswerByTechTeam: false,
  },
  reducers: {
    setAllSolutionsLoadingState: (state, action) => {
      state.isLoading = true;
    },
    setSingleSolutionsLoadingState: (state, action) => {
      state.isSingleSolutionLoading = true;
    },
    showSolutionsAllocation: (state, action) => {
      state.isAnswerByTechTeam = true;
    },
    hideSolutionsAllocation: (state, action) => {
      state.isAnswerByTechTeam = false;
    },
    loadAllSolutions: (state, action) => {
      const listObj = {};
      action.payload.solutions.forEach((value) => {
        listObj[value.id] = value;
      });
      state.byId = listObj;
      state.allIds = action.payload.solutions.map((value) => value.id);
      state.totalRecords = action.payload.totalRecords;
      state.filteredRecords = action.payload.filteredRecords;
      state.isLoading = false;
    },
    loadSingleSolution: (state, action) => {
      state.selectedSolution =
        action.payload && action.payload.length === 1
          ? action.payload[0]
          : null;
      state.isSingleSolutionLoading = false;
    },
  },
});

export const {
  setAllSolutionsLoadingState,
  setSingleSolutionsLoadingState,
  loadAllSolutions,
  loadSingleSolution,
  showSolutionsAllocation,
  hideSolutionsAllocation,
} = solutionsListSlice.actions;

export default solutionsListSlice.reducer;
